import React from "react";

const PNF = () => {
  return (
    <div className="flex justify-center">
      <h1 className="text-red-600">Page Not Found</h1>
    </div>
  );
};

export default PNF;
